<template>
	<v-dialog v-model="dialog" persistent scrollable max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase mr-4" 
				dark small v-on="on">
				{{'add model' | localize}}
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-spacer></v-spacer>
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Add new model to the trademark' | localize }} <span class="secondary--text">{{ trademark }}</span>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="black--text">
				<v-container grid-list-md>
					<v-form v-model="valid" ref="form" lazy-validation>
						<v-row>
							<v-col cols="12" sm="6" md="4">
								<v-text-field dense
									color="secondary"
									:label="'Model name' | localize"
									v-model="name"
									name="name"
									type="text"
									:rules="[rules.required]"
									@change="validName()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense 
									v-model.number="material"
									:items="levelItems"
									color="secondary"
									item-color="secondary"
									:label="'Material' | localize"
									:rules="[rules.required]"
									@change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense 
									v-model.number="manufacturing"
									:items="levelItems"
									color="secondary"
									item-color="secondary"
									:label="'Manufacturing' | localize"
									:rules="[rules.required]"
									@change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense
									v-model="designType"
									:items="items"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									color="secondary"
									item-color="secondary"
									:label="'Design type' | localize"
									:rules="[rules.required]"
									@change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense 
									v-model.number="design"
									:items="levelItems"
									color="secondary"
									item-color="secondary"
									:label="'Design level' | localize"
									:rules="[rules.required]"
									@change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense 
									v-model.number="variations"
									:items="levelItems"
									color="secondary"
									item-color="secondary"
									:label="'Variations' | localize"
									:rules="[rules.required]"
									@change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="12" md="12">
								<v-select dense
									return-object
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									v-model="functional_expansion"
									:items="functional_expansions"
									:clearable=true
									color="secondary"
									item-color="secondary"
									:label="'Functional expansion' | localize"
									@change="onceMore()">
								</v-select>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
				<v-row v-if="error" justify="center" class="mx-2 error--text">{{'Error' | localize }} =>  {{error}}</v-row>
				<v-row class="text-start text-pre-wrap mx-2">
					{{message}}
				</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize"
					:loading="loading" 
					:disabled="!valid || loading || calculating || Boolean(error)"
					@click="calculate"
				>{{'Calculate' | localize}}</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="!calculating || Boolean(error)"
					@click="addModel"
					>{{'Save' | localize}}</v-btn>
				<v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
					{{'Close' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { UnitCost, Investments, AvailabilityFrom } from '../../../functions/product';
import { PromoCodeGenerator, getMonth, localeNumber } from '../../../functions/common';
import localizeFilter from '../../../filters/localize.filter';

	export default {
		props: ['brand'],
		data () {
			return	{
				dialog: false,
				valid: false,
				message: '',
				error: '',
				calculating: false,
				trademark: this.brand.trademark,
				id: this.brand.id,
				rules: {
					required: value => !!value || localizeFilter('required field'),
				},
				items: ['classic', 'business', 'casual', 'innovative', 'art'],
				levelItems: [1, 2, 3, 4, 5],
				name: '',
				material: 1,
				manufacturing: 1,
				designType: '',
				functional_expansion: {},
				design: 1,
				variations: 1,

				investments: 0,
				unit_cost: 0,
				available_from: 1,
				available_till: 12,
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			locale() {
				return this.$store.getters.locale;
			},
			game() {
				return this.$store.getters.game;
			},
			team() {
				return this.$store.getters.team;
			},
			functional_expansions() {
				return this.$store.getters.FEATURES;
			}
		},
		methods: {
			
			calculate () {
				this.calculating = true	
				if(this.$refs.form.validate()) {
				/* new model parameters 
					@unitCost
					@r&dInvestments
					@r&dTime (completion) 
				*/
				
					if (!this.functional_expansion.text_en) {
						this.unit_cost = UnitCost(this.material, this.manufacturing, this.variations)
						this.investments = Investments(this.material, this.manufacturing, this.variations, this.design)
						this.available_from = AvailabilityFrom(this.material, this.manufacturing, this.variations, this.design)
					}
					else {
						this.unit_cost = UnitCost(
							this.material,
							this.manufacturing,
							this.variations,
							this.functional_expansion.value);
						this.investments = Investments(this.material,
							this.manufacturing,
							this.variations,
							this.design,
							this.functional_expansion.value);
						this.available_from = AvailabilityFrom(this.material,
							this.manufacturing,
							this.variations,
							this.design,
							this.functional_expansion.value);
					}

					if (!this.advanced_feature?.text_en) {
					this.unit_cost = UnitCost(this.material, this.manufacturing, this.variations)
					this.investments = Investments(this.material, this.manufacturing, this.variations, this.design)
					this.available_from = AvailabilityFrom(this.material, this.manufacturing, this.variations, this.design)
				}
				else {
					this.unit_cost = UnitCost(
						this.material,
						this.manufacturing,
						this.variations,
						this.advanced_feature.value);
					this.investments = Investments(this.material,
						this.manufacturing,
						this.variations,
						this.design,
						this.advanced_feature.value);
					this.available_from = AvailabilityFrom(this.material,
						this.manufacturing,
						this.variations,
						this.design,
						this.advanced_feature.value);
				}
				/* console.log(this.locale);*/
				if (this.locale == 'ro-RO') {
					this.message =`Vă rugăm să luați notă de parametrilor modelului ${this.name}:

					disponibilă din luna: ${getMonth(this.available_from)}
					cheltuielile pentru dezvoltare: $${localeNumber(this.investments, this.locale)}
					cost unitar: $${this.unit_cost}
					--------------------------------------------------------
				Dacă sunteți de acord, apăsați butonul "Salvare", altfel - apăsați "Închide"`
				} 
				else if (this.locale == 'ru-RU') {
					this.message =  `Пожалуйста, обратите внимание на параметры модели ${this.name}:

					доступна с месяца: ${getMonth(this.available_from)}
					расходы на её разработку составят: $${localeNumber(this.investments, this.locale)}
					себестоимость единицы продукции: $${this.unit_cost}
					--------------------------------------------------------
				Согласны? Нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
				}
				else {
					this.message = `Please note of the model ${this.name} specifications:

					available from: ${getMonth(this.available_from)}
					R&D spendings: $${localeNumber(this.investments, this.locale)}
					unit cost: $${this.unit_cost}
					--------------------------------------------------------
				If you agree, press the button "Save", else - press "Close"`
				}	
					this.calculating = true;
				}		
			},
			onceMore () {
				this.message = ''
				this.error = ''
				this.calculating = false
			},
			validName() {
				const inbrand = this.brand.models.find(mod => mod.model == this.name);
				if (inbrand) {
					this.error = `model name ${this.name} has already been used`;
					this.message = '';
				}
				else {
					this.onceMore();
				}
			}, 
			async addModel () {

				let af = '';
				if (this.functional_expansion?.text_en) {
					af = this.functional_expansion.text_en;
				}

				const id = '_' + PromoCodeGenerator(9);

				const prod = {
					gameId: this.game.id,
					round: this.game.round,
					productId: id,
					trademark: this.trademark,
					model: this.name,
					available_from: this.available_from,
					available_till: this.available_till,
					material: this.material,
					manufacturing: this.manufacturing,
					design_type: this.designType,
					design: this.design,
					variations: this.variations,
					advanced_feature: af,
					teamId: this.team.id,
					investments: this.investments,
					unit_cost: this.unit_cost,
				}
				/* console.log(prod) */	
				try {
					//add team product
					await this.$store.dispatch('addTeamProduct', prod);
					this.closeDialog();
				}
				catch (error) {
					this.$store.dispatch('setError', error.message)//throw error
				}
				this.closeDialog ();	
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.calculating = false
				this.message = ''
				this.error = ''
			}
		},
	}
</script>
